import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DateRangeElement } from '@iot-platform/iot-platform-utils';
import { Filter, FilterDefaultOptions } from '@iot-platform/models/common';
import { Subject } from 'rxjs';
import { DateRangeComponent } from '../../../date-range/date-range.component';
import { FilterComponent } from '../../models/filter.component';
import { AbstractFilterEngineFieldComponent } from '../abstract-filter-engine-field.component';

@Component({
  imports: [FlexLayoutModule, DateRangeComponent, MatIconButton, MatIcon],
  selector: 'iot-platform-ui-date-interval-field',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './date-interval-field.component.html'
})
export class DateIntervalFieldComponent extends AbstractFilterEngineFieldComponent<FilterDefaultOptions> implements FilterComponent {
  startDate!: DateRangeElement;
  endDate!: DateRangeElement;
  clearDateRangeFilters$ = new Subject<void>();

  onDateRangeChange(event: { startDate: DateRangeElement; endDate: DateRangeElement }): void {
    this.startDate = event.startDate;
    this.endDate = event.endDate;
  }

  onValidation(): void {
    const data = this.data() as FilterDefaultOptions;
    const filterStart: Filter = {};
    const filterEnd: Filter = {};
    const filters: Filter[] = [];
    filterStart.criteriaKey = data.criteriaKey + 'Start';
    filterStart.criteriaLabel = data.criteriaLabel + '_START';
    filterStart.criteriaOperatorStart = data?.criteriaOperatorStart;
    filterStart.criteriaOperatorStartKey = data?.criteriaOperatorStartKey;
    filterEnd.criteriaKey = data.criteriaKey + 'End';
    filterEnd.criteriaLabel = data.criteriaLabel + '_END';
    filterEnd.criteriaOperatorEnd = data?.criteriaOperatorEnd;
    filterEnd.criteriaOperatorEndKey = data?.criteriaOperatorEndKey;
    if (this.startDate) {
      filterStart.value = this.startDate.value;
      filterStart.label = this.startDate.label;
      filters.push(filterStart);
    }
    if (this.endDate) {
      filterEnd.value = this.endDate.value;
      filterEnd.label = this.endDate.label;
      filters.push(filterEnd);
    }
    this.dispatchFilterEvent(filters);
    this.clearDateRangeFilters$.next();
  }
}
